
import React from 'react';
import { FaFacebook, FaInstagram, FaEnvelope, FaWhatsapp, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { ORGANIZACION, SEDES, aniosDeTrayectoria } from '../data/organizacion';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Mi Lugar</h3>
          <p>Centro de Día y Centro Educativo Terapéutico</p>
          <p>Fundado por la {ORGANIZACION.fundadora} en {ORGANIZACION.fundacion}</p>
          <p>Más de {aniosDeTrayectoria()} años de trayectoria</p>
        </div>

        <div className="footer-section">
          <h3>Sede Temperley</h3>
          <p><FaMapMarkerAlt /> {SEDES[0].direccionCompleta}</p>
          <p><FaPhone /> {SEDES[0].telefonoTexto}</p>
          <a href={SEDES[0].whatsapp} className="footer-link">
            <FaWhatsapp /> WhatsApp
          </a>
        </div>

        <div className="footer-section">
          <h3>Sede Glew</h3>
          <p><FaMapMarkerAlt /> {SEDES[1].direccionCompleta}</p>
          <p><FaPhone /> {SEDES[1].telefonoTexto}</p>
          <a href={SEDES[1].whatsapp} className="footer-link">
            <FaWhatsapp /> WhatsApp
          </a>
        </div>

        <div className="footer-section">
          <h3>Seguinos</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/MiLugarTemperley" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaFacebook />
            </a>
            <a href="https://www.instagram.com/cet.milugar/" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaInstagram />
            </a>
            <a href="mailto:tulugar1@hotmail.com" className="social-icon">
              <FaEnvelope />
            </a>
          </div>
        </div>
      </div>

      <div className="copyright">
        <p>&copy; {new Date().getFullYear()} Mi Lugar - Todos los derechos reservados</p>
      </div>
    </footer>
  );
};

export default Footer;
